

// get the year of the first next season after the transfer date, for full-year and cross-year seasons
export const getYearOfFirstNextSeason = (transferDate: Date, isCrossYearSeason: boolean): number => {
  const month = transferDate.getMonth();
  const year = transferDate.getFullYear();

  if (isCrossYearSeason) {
    // if the transfer happens in May (index 4) or later, we assume the first next season starts after that summer
    return month < 4
      ? year - 1
      : year;
  }

  // if the transfer happens in November (index 10) or later, we assume the first next season starts next year
  return month < 10
    ? year
    : year + 1;
};


// get the approximate start date of a season based on the season string
export const getSeasonStartDate = (seasonString: string): Date => {
  const seasonStringArray = seasonString.split('/');
  let year = seasonStringArray[0];
  let month = 1;
  if (seasonStringArray.length === 2) {
    month = 7;
    year = '20' + year;
  }
  return new Date(Number(year), month, 1);
};


// get the first and last season from a list of seasons
export const getFirstAndLastSeason = (seasons: string[]): { firstSeason?: string, lastSeason?: string } => {
  if (seasons.length === 0) return {};

  if (seasons.length === 1) {
    return { firstSeason: seasons[0] };
  }

  const sortedSeasons = seasons.sort((a, b) => {
    const aStartDate = getSeasonStartDate(a);
    const bStartDate = getSeasonStartDate(b);
    return aStartDate.getTime() - bStartDate.getTime();
  });

  const firstSeason = sortedSeasons[0];
  const lastSeason = sortedSeasons[sortedSeasons.length - 1];

  if (firstSeason === lastSeason) {
    return { firstSeason };
  }
  return { firstSeason, lastSeason };
};
